import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs } from "../utils/index"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"

export default class AllArticles extends Component {
  constructor(obj) {
    super(obj)

    this.splitText = qsa("[data-split]", this.el)
    this.textSplitter = new TextSplitScrollTrigger({
      el: this.el,
      splitText: this.splitText,
      animate: this.animate.bind(this),
    })
  }

  animate() {
    const title = qsa(".title .char-1", this.el)
    const articles = qsa(".article", this.el)

    gsap.from(title, {
      y: "100%",
      stagger: 0.05,
      duration: 1.2,
      scrollTrigger: {
        trigger: title,
        start: "top bottom",
      },
    })
    gsap.from(articles, {
      y: "100%",
      autoAlpha: 0,
      stagger: 0.1,
      duration: 1.2,
      scrollTrigger: {
        trigger: articles,
        start: "top bottom",
      },
    })
  }
}
